import type { ErrorKind } from '@/api/errors';

/** Map a retryable error kind to its i18n copy base (`<base>.title` / `<base>.body`). */
export function errorCopyBase(kind: ErrorKind): string {
  switch (kind) {
    case 'NETWORK':
      return 'error.network';
    case 'SERVER':
      return 'error.server';
    case 'NOT_AVAILABLE':
      return 'error.notAvailable';
    case 'RATE_LIMIT':
      return 'error.rateLimit';
    default:
      return 'error.unknown';
  }
}
